const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

export const getCompanyDocumentCategoryViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Categorie Documenti'),
      fields: [{ text: t('Titolo'), value: display(item.title) }],
    },
  ];
};
